<template>
  <div>
    <social-header v-if="currentEnv" title="常见问题"></social-header>
    <div class="column-list">
      <div class="column-item" v-for="item in columnList" :key="item.id" @click="toQuestionAnswer(item.id)">
        <div class="column-text">{{item.columnName}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import SocialHeader from '../../components/social-header.vue';
import { isWeiXin, isDingDing, changeDocumentTitle } from '../../service/environment'
export default {
  name: 'questionColumn',
  data: function () {
    return {
      columnList: []
    }
  },
  components: {
    SocialHeader
  },
  computed: {
    currentEnv () {
      if (isWeiXin()) {
        return false
      } else if (isDingDing()) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    toQuestionAnswer (id) {
      let question = this.columnList.find(item => item.id === id)
      console.log(question)
      sessionStorage.setItem('question', JSON.stringify(question))
      this.$router.push(`/activity/questionAnswer/` + id)
    }
  },
  created () {
    changeDocumentTitle('常见问题')
  },
  beforeMount () {
    let list = JSON.parse(sessionStorage.getItem('qaContent')).map(item => {
      return item.columns.map(item1 => {
        return {
          ...item1
        }
      })
    })
    this.columnList = list.reduce((arr, item) => arr.concat(item), [])
  }
};
</script>

<style scoped>
.column-list{
  width: 100%;
  padding-top: 1.25rem;
  box-sizing: border-box;
}
.column-item{
  width: 92%;
  height: 6rem;
  background-image: url('../../static/img/question_bg.png');
  background-size: 100% 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding-left: 1.25rem;
  box-sizing: border-box;
  margin-bottom: 1.25rem;
}
.column-text{
  width: 12.5rem;
  font-size: 1.38rem;
  color: #111E36;
  line-height: 1.38rem;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/questionColumn.vue